import React from 'react';

  import imgProfileDefault from '../../assets/img/blank.png';
  import {useTranslation} from "react-i18next";

  function ProfilePhotoCard(props) {
      const { t } = useTranslation();
      const userAvatar = props.personalInfo.avatar ? props.personalInfo.avatar : imgProfileDefault;

      return (
          <div className="card w-100 position-relative overflow-hidden">
              <div className="card-body p-4">
                  <h5 className="card-title fw-semibold">{t('Profile Picture')}</h5>
                  <p className="card-subtitle mb-4">{t('Your profile picture is taken from your Google account.')}</p>

                  <div className="text-center">
                      <img src={userAvatar} alt="Profile pic" className="img-fluid rounded-circle" width="120" height="120"/>
                  </div>
              </div>
          </div>
      );
  }

  export default ProfilePhotoCard;
  